import React, { useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";
import Background from "components/common/Background";
import LayoutAuth from "assets/img/LayoutAUth.jpg"; // Background image (LayoutAuth as background)
import LayoutLogin from "assets/img/Login.png"; // Foreground image (LayoutLogin above background)

const AuthLayout = () => {
  const getToken = localStorage.getItem("bearerToken");
  const navigate = useNavigate();

  useEffect(() => {
    if (getToken) {
      navigate("/", { replace: true });
    }
  }, [getToken]);

  return (
    <div className=" position-relative min-vh-100">
      <Background
        image={LayoutAuth}
        foregroundImage={null}
        className="bg-image-center min-vh-100"
      />

      <Card
        className="position-absolute "
        style={{
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "25%",
        }}
      >
        <Card.Header className="bg-shape bg-circle-shape text-center p-2">
          <Link
            to="#"
            className="text-white font-sans-serif text-decoration-none fw-bolder fs-7 z-2 position-relative"
          >
            Tababek (T-Claims)
          </Link>
        </Card.Header>
        <Card.Body className="p-4">
          <Outlet />
        </Card.Body>
      </Card>
    </div>
  );
};

export default AuthLayout;
